
<template>
  <IndexClientPortfolios></IndexClientPortfolios>
</template>

<script>

export default {
  name: 'ClientsPortfolios',
  components: {
    IndexClientPortfolios: () => import('@/_backoffice/_registrations/components/client_portfolio/IndexClientPortfolios.vue'),
  },
}
</script>
